import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext.jsx';
import { formatMoney, calculateDiscountPercent } from '@store/shared';

export function ProductCard({ product }) {
  const { language, t } = useLanguage();

  if (!product) return null;

  const isArabic = language === 'ar';
  const name = isArabic ? product.name_ar : product.name_fr;
  const regularPrice = product.regular_price_cents;
  const salePrice = product.sale_price_cents;
  const hasDiscount = salePrice && salePrice < regularPrice;
  const discountPercent = hasDiscount ? calculateDiscountPercent(regularPrice, salePrice) : 0;
  const isOutOfStock = product.stock_status === 'outofstock';

  return (
    <article className="product-card">
      <Link to={`/produit/${product.slug}`} className="product-media">
        {product.main_image_url ? (
          <img src={product.main_image_url} alt={name} loading="lazy" />
        ) : (
          <div style={{ color: '#94a3b8', fontSize: '2.5rem' }}>🚗</div>
        )}

        {hasDiscount && (
          <span className="product-badge badge-sale">
            -{discountPercent}%
          </span>
        )}
        {!hasDiscount && product.is_featured === 1 && (
          <span className="product-badge badge-new">
            {t('sortNewest')}
          </span>
        )}
      </Link>

      <div className="product-body">
        {product.fitment_type === 'universal' && (
          <span className="product-category-tag">{t('universalFit')}</span>
        )}
        {product.fitment_type === 'specific' && (
          <span className="product-category-tag" style={{ color: '#ea580c' }}>{t('specificFit')}</span>
        )}

        <h3 className="product-title">
          <Link to={`/produit/${product.slug}`}>{name}</Link>
        </h3>

        <div className="product-price-row">
          <span className="product-price">
            {formatMoney(hasDiscount ? salePrice : regularPrice, 'MAD', language)}
          </span>
          {hasDiscount && (
            <span className="product-regular-price">
              {formatMoney(regularPrice, 'MAD', language)}
            </span>
          )}
        </div>

        <Link
          to={`/produit/${product.slug}`}
          className={`btn ${isOutOfStock ? 'btn-outline' : 'btn-primary'}`}
          style={{ width: '100%', marginTop: '0.5rem', fontSize: '0.875rem' }}
        >
          {isOutOfStock ? t('outOfStock') : t('orderNow')}
        </Link>
      </div>
    </article>
  );
}
